module.exports = __webpack_public_path__ + "static/media/02_sognolucido.1aa0c428.jpg";